import * as React from 'react';
import * as _ from 'lodash/fp';
import styled from 'styled-components';

import { getColor, getFontSize } from '@process-advisor/process-miner/shared/theme';
import { StyledTextField } from '@process-advisor/process-miner/components/shared/styledTextField'

const Label = styled.div`
    margin-right: 5px;
    font-size: ${getFontSize('smaller')};
    color: ${getColor('blue')};
    border-bottom: none !important;
`;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 3px 0;
`;

type Props = {
    value: number;
    label?: string;
    onChange?: (val: number) => void;
    onBlur?: (val: number) => void;
    className?: string,
    min?: number;
    max?: number;
    disabled?: boolean
};

export const NumberInput: React.FC<Props> = ({
    value,
    onChange = _.noop,
    onBlur = _.noop,
    className,
    label,
    min,
    max,
    disabled,
}) => {
    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value >= 0) {onChange(event.target.value)};
    };

    const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const finalValue = Number(event.target.value);

        if (min && finalValue < min) {
            onChange(min);
            return onBlur(min);
        }

        if (max && finalValue > max) {
            onChange(max);
            return onBlur(max);
        }

        onBlur(finalValue);
    };

    return (
        <Wrapper className={className}>
            { label && <Label>{label}</Label>}
            <StyledTextField
                disabled={disabled}
                onBlur={handleOnBlur}
                onChange={handleOnChange}
                value={value}
                variant="outlined"
                type="number" />
        </Wrapper>
    );
};
